module.exports = "/_next/static/images/7d47d9686f10effa5ea6565e87b1abe0-Nubank_HickDuarte_57380_lg.png";